import { render, staticRenderFns } from "./user-transfer.vue?vue&type=template&id=85aca2c2&scoped=true"
import script from "./user-transfer.vue?vue&type=script&lang=js"
export * from "./user-transfer.vue?vue&type=script&lang=js"
import style0 from "./user-transfer.vue?vue&type=style&index=0&id=85aca2c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aca2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85aca2c2')) {
      api.createRecord('85aca2c2', component.options)
    } else {
      api.reload('85aca2c2', component.options)
    }
    module.hot.accept("./user-transfer.vue?vue&type=template&id=85aca2c2&scoped=true", function () {
      api.rerender('85aca2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/user-transfer.vue"
export default component.exports